/**
 * Shape conversions between the 7x24 local matrix and the flat row objects ag-grid holds.
 * No Vue or ag-grid dependency.
 */

import { HOURS_PER_DAY, hasPrice, newEmptyMatrix } from './strike-price-week';

const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** Column id of the pinned day-name column. */
export const DAY_COL = 'dayLabel';

export function hourField(hour) {
  return 'h' + hour;
}

export function formatHour(hour) {
  if (hour === 0) return '12am';
  if (hour < 12) return hour + 'am';
  if (hour === 12) return '12pm';
  return (hour - 12) + 'pm';
}

/** One row object per day, keyed by `id` so ag-grid can update rows in place. */
export function buildRows(matrix) {
  return matrix.map((row, day) => {
    const data = { id: String(day), [DAY_COL]: DAY_LABELS[day] };
    row.forEach((value, hour) => { data[hourField(hour)] = value; });
    return data;
  });
}

export function rowsToMatrix(rows) {
  const matrix = newEmptyMatrix();
  rows.forEach(data => {
    const day = Number(data.id);
    for (let hour = 0; hour < HOURS_PER_DAY; hour++) {
      matrix[day][hour] = data[hourField(hour)];
    }
  });
  return matrix;
}

/** Bounds the colour scale; a matrix with no prices collapses to a zero-width range. */
export function priceRange(matrix) {
  let min = Infinity;
  let max = -Infinity;
  matrix.forEach(row => row.forEach(value => {
    if (hasPrice(value)) {
      min = Math.min(min, value);
      max = Math.max(max, value);
    }
  }));
  return min === Infinity ? { min: 0, max: 0 } : { min, max };
}
